import React from 'react';
import MainTemplate from '../mainTemplate';
import { ReactTitle } from 'react-meta-tags';
import ReportsComponent from '../../shared/reports';

const ReportsBSC = () => {

  return <MainTemplate>
    <ReactTitle title={`Reportes - Reverse Factoring`} />
    <ReportsComponent />
  </MainTemplate>;
};

export default ReportsBSC;